export enum AuditLogsColumnsTableEnum {
  DateOfChange = 'dateOfChange',
  User = 'user',
  Activity = 'activity',
  Outcome = 'outcome',
  Remarks = 'remarks',
}
